import {
  URL_GET_DATA_FOR_EDIT_PAYMENT,
  URL_GET_ORDER_DOCUMENTS,
  URL_GET_ORDER_ITEMS_PAGED,
  URL_GET_ORDER_ITEMS_ATTRIBUTES,
  URL_GET_ORDER_ITEMS_HISTORY,
  URL_GET_ORDER_PAYMENTS,
} from "@/requests/order/order";
import { URL_GET_ORDERS_PAGED } from "@/requests/order/order";
import MockAdapter from "axios-mock-adapter/types";
import GenericTableResponse from "@/models/api/GenericTableResponse";
import { OrderListItem } from "@/models/api/orders/OrderListItem";
import OrderItemsListItem from "@/models/api/orders/OrderItemsListItem";
import OrderItemsAttributesItem from "@/models/api/orders/OrderItemsAttributesItem";
import OrderPaymentsListItem from "@/models/api/orders/OrderPaymentsListItem";
import OrderItemHistoryListItem from "@/models/api/orders/OrderItemHistoryListItem";
import getOrderItemsHistoryResponse from "./responses/getOrderItemsHistory";
import getOrdersTable from "./responses/getOrdersTable";
import getOrderItems from "./responses/getOrderItems";
import getOrderItemsAttributes from "./responses/getOrderItemsAttributes";
import getOrderPayments from "./responses/getOrderPayments";
import getOrderDocuments from "./responses/getOrderDocuments";
import getDataForEditPayment from "./responses/getDataForEditPayment";

export const orderMock = (mock: MockAdapter): void => {
  mock.onGet(URL_GET_ORDER_ITEMS_HISTORY).reply(200, getOrderItemsHistoryResponse as Array<OrderItemHistoryListItem>);

  mock.onGet(URL_GET_ORDERS_PAGED).reply(200, getOrdersTable as GenericTableResponse<OrderListItem>);

  mock.onGet(URL_GET_ORDER_ITEMS_PAGED).reply(200, getOrderItems as GenericTableResponse<OrderItemsListItem>);

  mock.onGet(URL_GET_ORDER_ITEMS_ATTRIBUTES).reply(200, getOrderItemsAttributes as Array<OrderItemsAttributesItem>);

  mock.onGet(URL_GET_ORDER_PAYMENTS).reply(200, getOrderPayments as Array<OrderPaymentsListItem>);

  mock.onGet(URL_GET_ORDER_DOCUMENTS).reply(200, getOrderDocuments);

  mock.onGet(URL_GET_DATA_FOR_EDIT_PAYMENT).reply(200, getDataForEditPayment);
};
